import { useSearchTagsQuery } from "../../../Queries/FilterQueries";
import { SelectChangeEvent } from "@mui/material";

export function useTagFilter(
  tagFilters: string[],
  setTagFilters: (tags: string[]) => void,
  clientId?: string
) {
  const { data: tags } = useSearchTagsQuery(clientId);

  const tagLabel = () =>
    tagFilters.length > 0
      ? tagFilters.length > 1
        ? tagFilters[0] + ` +${tagFilters.length - 1}`
        : tagFilters[0]
      : "Tags";

  const handleTagChange = (event: SelectChangeEvent) => {
    const tags = event.target.value as unknown as string[];
    if (tags) {
      setTagFilters(tags);
    }
  };

  return {
    tagLabel,
    handleTagChange,
    searchableTags: tags || [],
  };
}
